<template>
  <el-row class="aligner">
    <el-col :span="8">
      <p
        class="pie-label"
        v-for="(value, key) in dict"
        :key="key"
      >
        <span class="label-color">C</span>
        {{key}}: {{(value * 100 / dataTotal).toFixed(2)}} %
      </p>
    </el-col>
    <el-col :span="16">
      <svg
        viewBox="0 0 64 64"
        class="pie"
      >
        <circle
          v-for="(item, index) in dataObjects"
          :key="index"
          :style="{strokeDasharray: `${item.relativeSize} 100`, strokeDashoffset: item.offset}"
          r="25%"
          cx="50%"
          cy="50%"
        ></circle>
      </svg>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'PieChart',
  props: ['dict'],
  computed: {
    data () {
      return Object.keys(this.dict).map(k => this.dict[k])
    },
    dataTotal () {
      return this.data.reduce((previous, current) => previous + current)
    },
    dataObjects () {
      let startingPoint = 0
      let dataTotal = this.dataTotal

      let objects = this.data.map(item => {
        let relativeSize = item * 100 / dataTotal

        let dataObject = { relativeSize: relativeSize, offset: -startingPoint }
        startingPoint += relativeSize

        return dataObject
      })

      if (objects.length) objects[objects.length - 1].relativeSize++

      return objects
    }
  }
}
</script>

<style lang="scss">
.pie {
  background: inherit;
  border-radius: 50%;
}

.pie circle {
  fill: none;
  stroke: gray;
  stroke-width: 32;
  animation: rotate 1.5s ease-in;
}

.label-color {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
}

$colors: #90c3d8, #6d8b97, #dbf3fc, green, gray, purple;

@for $i from 1 through length($colors) {
  .pie circle:nth-child(#{$i}) {
    stroke: nth($colors, $i);
  }

  .pie-label:nth-child(#{$i}) .label-color {
    background-color: nth($colors, $i);
    color: nth($colors, $i);
  }
}
</style>
